<template>
   <page-loader v-if="loadingStatus == 'loading'" />
   <div v-else-if="loadingStatus === 'failed'">
      <div v-if="errorMessage === 'not_shared'">
         <AlertMessage type="error" class="max-w-xl m-auto mt-12">
            <template #title>URL does not match</template>
            <template #body>The provided url does not match a shared profile, please ensure the url is
               correct</template>
         </AlertMessage>
      </div>
      <div v-else>
         <AlertMessage type="error" class="max-w-xl m-auto mt-12">
            <template #title>Something went wrong</template>
            <template #body>please contact
               <a href="mailto:help@livingdna.com" class="font-semibold text-cobalt-500">help@livingdna.com</a>
               for more assistance</template>
         </AlertMessage>
      </div>
   </div>
   <div v-else class="main share-page text-start">
       <header class="navbar navbar-expand-lg navbar-dark custom-navbar">
    <div class="container">
      <a href="#" class="navbar-brand">
        <img :src="Logo" alt="Logo" class="img-fluid">
      </a>
      <div class="right-bar">
      </div>
    </div>
  </header>
      <section class="container-custom px-3 my-3 my-md-5 result-wrapper">
         <div class="card">
            <BakerOverview />
         </div>
      </section>
      <FooterbakerSection />
   </div>
</template>
<script setup>
import Logo from '@/assets/images/logos/living-dna-updated-logo.svg'
import { ref, computed, watch } from "vue";
import FooterbakerSection from "@/view/sharing/FooterbakerSection.vue";
import BakerOverview from "@/view/sharing/BakerOverview.vue";
import AlertMessage from "@/components/AlertMessage.vue";
import { useSharingStore } from "@/store/sharing";
import { useRoute } from "vue-router";
import { useLoading } from "@/composables/useLoading";
import { useStore } from "vuex";
import { getBakersPublicDetailResult } from "@/services/bakers";

const store = useStore();
const introduction = ref(null);
// barcode from profile
const barcode = computed(() => {
  return store.getters.profile?.profile?.barcode || null;
});
const sharingStore = useSharingStore();
const route = useRoute();
const { loadingStatus, finishLoading, failLoading, errorMessage } = useLoading();
// fetch bakers result
watch(
  barcode,
  async (newBarcode) => {
      console.log("Barcode changed:", newBarcode);
    try {
      const res = await getBakersPublicDetailResult(route.params.uuid);
      console.log('BAKERS REPORT' ,res.bakers_report);
      introduction.value = res?.bakers_report;
    } catch (e) {
      console.error("Failed to load bakers result", e);
    }
  },
  { immediate: true }
);
// parse results
const parsedResults = computed(() => {
  if (!introduction.value?.results) return null;

  try {
    return JSON.parse(introduction.value.results);
  } catch {
    return null;
  }
});
// traits list
const traits = computed(() => {
  return parsedResults.value?.traits
    ? Object.keys(parsedResults.value.traits)
    : [];
});
console.log(traits);
sharingStore
  .getPublicProfile(route.params.uuid)
  .then(() => {
    if (
      !sharingStore.autosomalResult &&
      !sharingStore.motherlineResult &&
      !sharingStore.fatherlineResult
    ) {
      failLoading("no_sharing");
    }
    finishLoading();
  })
  .catch((err) => {
    if (err.response?.status === 404) {
      return failLoading("not_shared");
    }
    failLoading("general");
  });
</script>
<style lang="scss">
.share-page {
   .t-14 {
      font-size: 14px;
   }

   .grid {
      display: grid;
   }

   .gap-6 {
      gap: 24px;
   }

   .grid-cols-2 {
      grid-template-columns: 1fr;
   }

   a {
      text-decoration: none;
   }

   .scroll-snap-section {
      scroll-margin: 125px;
   }

   .badge-circular {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: inline-flex;
      flex-shrink: 0;
   }

   .card {
      padding: 20px;
      border: none;
   }

   .container-custom {
      width: 100%;
      max-width: 1060px;
      margin-inline: auto;
   }

   .card-grey {
      background: #f9fafb;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
      ;
   }

   .card-maternal {
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
      max-width: 570px;
      border-top: 4px solid transparent;

      .card-body {
         padding: 0;
      }
   }

   .border-red {
      border-color: #d40b55;
   }

   .text-red {
      color: #d40b55;
   }

   .text-blue {
      color: #1a3a77;
   }

   .border-blue {
      border-color: #1a3a77;
   }

   .avtar-100 {
      width: 100px;
      height: 100px;
      border-radius: 50%;
   }

   h1 {
      font-size: 24px;
   }

   h2 {
      font-size: 22px;
      margin-bottom: 30px;
   }

   h3 {
      font-size: 18px;
   }

   h4 {
      font-size: 16px;
   }

   @media(min-width:561px) {
      .grid-cols-2 {
         grid-template-columns: repeat(2, 1fr);
      }
   }
   @media(min-width:768px) {
      h1 {
         font-size: 30px;
      }

      h2 {
         font-size: 24px;
         margin-bottom: 30px;
      }

      h3 {
         font-size: 20px;
      }

      h4 {
         font-size: 18px;
      }
   }
}
</style>
